import { createContext, useState, ReactNode, useMemo } from 'react';
import { TDataDogContext } from './types';
import { updateContext } from '../Datadog';

export const DatadogContext = createContext<TDataDogContext>({
  appBuildVer: '',
  appNameVal: '',
  setAppBuildVer: () => null,
  setAppName: () => null,
  setAppLevelContext: () => {},
});

export const updateAppLevelCtx = (appName: string, contextData: object) => {
  if (appName && contextData) {
    const appData = { [appName]: contextData };
    updateContext('appLevelData', appData);
  }
};

export const DatadogProvider = ({ children }: { children: ReactNode }) => {
  const [customAppBuildVer, setCustomAppBuildVer] = useState<string>('');
  const [appName, setAppName] = useState<string>('');
  const value = useMemo(
    () => ({
      appBuildVer: customAppBuildVer,
      appNameVal: appName,
      setAppBuildVer: setCustomAppBuildVer,
      setAppName: setAppName,
      setAppLevelContext: (contextData: object) => updateAppLevelCtx(appName, contextData),
    }),
    [appName, customAppBuildVer]
  );
  return <DatadogContext.Provider value={value}>{children}</DatadogContext.Provider>;
};
